import { DeviceState } from "..";

export const isSelectAll = ({ devices, selected_devicesIds }: DeviceState): boolean => {
    if (!selected_devicesIds.length || !devices.length) return false;

    return devices.map((device) => device.id).every((id) => selected_devicesIds.includes(id));
};
